import { AppRoutes } from 'containers/App/routes';
import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';

export const externalDatabasesRoot = 'externalDatabases';
export const externalDatabasesOverviewRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${externalDatabasesRoot}`;
export const EXTERNAL_DATABASE_ROUTE_PARAMS = {
  externalDatabaseName: 'externalDatabaseName',
};
export const externalDatabasesDetailRoute = `${externalDatabasesOverviewRoute}/:${EXTERNAL_DATABASE_ROUTE_PARAMS.externalDatabaseName}/edit`;
